import { render } from "./wenku.vue?vue&type=template&id=9e62a462&scoped=true"
import script from "./wenku.vue?vue&type=script&lang=js"
export * from "./wenku.vue?vue&type=script&lang=js"

import "./wenku.vue?vue&type=style&index=0&id=9e62a462&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9e62a462"

export default script